module.exports = __webpack_public_path__ + "media/images/austria-964aeff3e130238c40f072307bbd39f5.png";